import { useLocation, useNavigate } from "react-router-dom";
import { URLdecode, URLencode } from "../../utils/url";

function CustomerModalContainer({ value, order }) {
  const navigate = useNavigate();
  const location = useLocation();
  const params = URLdecode();
  // const [modal, setModal] = useState(false);

  const handleCustomerClick = () => {
    // console.log("object", location.pathname, order);
    navigate(
      `${location.pathname}?${URLencode({ ...params, order: order?._id })}`,
      { replace: true }
    );
  };

  return (
    <div className="cursor-pointer" onClick={() => handleCustomerClick()}>
      {/* <CustomerDetailModal data={order} open={modal} setOpen={setModal} callback={callback} /> */}
      <span className="text-xs text-primary1">{value}</span>
    </div>
  );
}

export default CustomerModalContainer;
